export const getStyles = (theme) => ({
    navbar: {
        left: '85px',
        right: 0,
        zIndex: 999,
        height: "75px",
        flexWrap: 'wrap',
        backgroundColor: '#F3F5F7',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        alignSelf: 'center',
        padding: '0px 20px 0px 20px',
    },
    navLeftContent: {
        display: 'flex',
        alignItems: 'center',
        alignSelf: 'center',
    },
    serviceBtn: {
        width: '60px',
        height: '16px',
        borderRadius: '0',
        borderTopLeftRadius: '5px',
        borderBottomRightRadius: '5px',
        color: '#FFFFFF',
        backgroundColor: '#000000'
    },
    navRightContent: {
        display: 'flex',
        alignItems: 'center',
        alignSelf: 'center',
    },
    navbarBrand: {
        height: '37.48px',
        width: '110px',
        marginRight: '20px',
        display: 'flex',
        alignItems: 'center',
    },
    iconButton: {
        width: '18px',
        height: '12px',
        top: '6px',
        left: '3px',
        gap: '0px',
        border: '1.5px 0px 0px 0px',
        opacity: ' 0px',
        color: '#FFFFFF'
    }
})